<div class="h-1">
  @if (appStore.loading()) {
    <p-progressbar mode="indeterminate" [style]="{ height: '4px' }" />
  }
</div>
